module.exports = __webpack_public_path__ + "img/bg-capacity-item.b0b6234f.png";